import { useMemo } from 'react';
import CreatableSelect from 'react-select/creatable';
import styles from './select-creatable.module.scss';

type Props = {
  value: any;
  options: any[];
  onChange: (value: any) => void;
  onCreateOption: (value: string) => void;
  label: string;
  className?: string;
  error?: boolean;
  inline?: boolean;
  placeholder?: string;
  subTitle?: string;
};

function SelectCreatable(props: Props) {
  const {
    value,
    options,
    onChange,
    onCreateOption,
    label,
    className,
    error,
    inline,
    placeholder,
    subTitle
  } = props;

  const wrapperClasses = useMemo(() => {
    const classes = [styles.wrapper, className];
    if (inline) {
      classes.push(styles.inline);
    }
    if (error) {
      classes.push(styles.error);
    }
    return classes.join(' ').trim();
  }, [className, error, inline]);

  return (
    <div className={wrapperClasses}>
      <div className={styles.header}>
        <div className={styles.headerLabel}>{label}</div>
      </div>
      <div className={styles.selectWrapper}>
        <CreatableSelect
          placeholder={placeholder}
          isClearable
          value={value}
          options={options}
          onChange={onChange}
          onCreateOption={onCreateOption}/>
        {subTitle && <div className={styles.subtitle}>{subTitle}</div>}
      </div>
    </div>
  );
}

export default SelectCreatable;
